// extracted by mini-css-extract-plugin
export var accordion = "_bi-0";
export var chevron = "_bi-3";
export var closed = "_bi-2";
export var content = "_bi-4";
export var open = "_bi-1";
export var rotate = "_bi-5";